/**
 * v-track ディレクティブ
 * ボタンクリックを自動的にトラッキングする
 *
 * 使用例:
 *   <v-btn v-track="'layer-add'">レイヤー追加</v-btn>
 *   <v-btn v-track="{ label: 'print', category: 'feature' }">印刷</v-btn>
 *   <v-btn v-track.disabled="'test'">トラッキング無効</v-btn>
 */

import { getUsageTracker } from '../utils/usageTracker'

// 除外すべき要素のセレクター
const EXCLUDED_SELECTORS = ['.v-slider', '.v-range-slider', '.v-input--slider', '[data-track-exclude]', '.no-track']

export default {
  mounted(el, binding, vnode) {
    // 除外判定
    if (binding.modifiers.disabled) {
      return
    }

    // 親要素が除外対象かチェック
    const isExcluded = EXCLUDED_SELECTORS.some((selector) => {
      return el.closest(selector) !== null
    })

    if (isExcluded) {
      return
    }

    // トラッキング情報を取得
    let label = ''
    let category = 'button'
    let value = null

    if (typeof binding.value === 'string') {
      // 文字列の場合: v-track="'layer-add'"
      label = binding.value
    } else if (typeof binding.value === 'object' && binding.value !== null) {
      // オブジェクトの場合: v-track="{ label: 'print', category: 'feature' }"
      label = binding.value.label || ''
      category = binding.value.category || 'button'
      value = binding.value.value || null
    } else {
      // 値が指定されていない場合、要素のテキストを使用
      label = el.textContent?.trim() || el.getAttribute('aria-label') || 'unknown'
    }

    // コンポーネント名を取得（Vue 3では異なる方法で取得）
    const componentName = vnode.ctx?.type?.name || vnode.ctx?.$options?.name || 'unknown'

    // クリックイベントハンドラー
    const clickHandler = (event) => {
      // Vuex storeを取得
      const store = vnode.ctx?.$store || null
      const tracker = getUsageTracker(undefined, store)

      if (!tracker) {
        console.warn('[v-track] UsageTracker not initialized')
        return
      }

      // ボタンのテキストを取得（実際にユーザーが見ているテキスト）
      const buttonText = el.textContent?.trim() || ''

      // トラッキング実行
      tracker.trackEvent(category, 'click', label, {
        component: componentName,
        text: buttonText,
        ...(value && { value }),
      })

    }

    // イベントリスナーを追加
    el.addEventListener('click', clickHandler)

    // クリーンアップ用にハンドラーを保存
    el._trackClickHandler = clickHandler
  },

  unmounted(el) {
    // イベントリスナーを削除
    if (el._trackClickHandler) {
      el.removeEventListener('click', el._trackClickHandler)
      delete el._trackClickHandler
    }
  },
}
